import useFetch from '@hooks/useFetch';

const usePopularGoals = () => {
  const { data, ...rest } = useFetch('v2/topology/popular_goals/');
  return { popularGoals: data, ...rest };
};

export default usePopularGoals;
